/**
 * @ngdoc controller
 * @name reserveDevice
 *
 * @description
 * _Please update the description and dependencies._
 *
 * @requires $scope
 * */

(function () {
  'use strict';
  angular
    .module('eclipseApp.reserveDevice')
    .controller('uteReserveDeviceNRSFormCtrl', _controller);

  _controller.$inject = ['$scope', '$rootScope', '$location', 'commonService', 'uteReserveDeviceNRSDataService', 'notifierService', 'uteLocale'];

  /* @ngInject */
  function _controller($scope, $rootScope, $location, commonService, uteReserveDeviceNRSDataService, notifierService, uteLocale) {

    var vm = this; 	// jshint ignore:line

    vm.salesForceIframeUrl = '';
    vm.encryptedString = '';
    vm.encryptedSignature = '';

    activate();

    function activate() {
      $rootScope.salesForceFailed = false;
      //myrAccountOverviewService.getBrtSwitches(function (_temp) {
      //  if (_temp.result === 'success') {
      //    if (_temp.data.length > 0) {
      //      for (var i = 0; i < _temp.data.length; i++) {
      //        if (_temp.data[i].id === 'NRS') {
      //          if (_temp.data[i].switchIsOn) {
      $rootScope.sfnrs = true;
      //}
      //}
      //}
      //}
      //$rootScope.sfnrs = true; //debug
      if ($rootScope.sfnrs) {
        var _accountDetails = commonService.accountDetails;
        var _userInfo = $rootScope.userInfo;

        var _ctn = '';
        var _ban = '';
        var _lang = uteLocale.language;
        var _email = '';
        var _arrayLength = _accountDetails.length;

        if (_arrayLength > 0) {
          _ban = _accountDetails[0].accountNumber;
          _email = _accountDetails[0].contactEmail;

          angular.forEach(_accountDetails[0].subscriberServices, function (subscriberServices) {
            angular.forEach(subscriberServices, function (value, key) {
              if (key == 'wireless') {
                _ctn = value.subscriberNo;

              }
            });
          });
        }

        _ban = (angular.isDefined($rootScope.userInfo.selectedAccountNumber) && $rootScope.userInfo.selectedAccountNumber !== '') ? $rootScope.userInfo.selectedAccountNumber : _ban;
        _ctn = (angular.isDefined($rootScope.userInfo.selectedSubscriberNo) && $rootScope.userInfo.selectedSubscriberNo !== '') ? $rootScope.userInfo.selectedSubscriberNo : _ctn;

        var _cancelUrl = $location.absUrl().replace($location.path(), '/my-account/overview');

        var _req = {
          applicationId: 'fido.com',
          ctn: _ctn,
          ban: _ban,
          email: _email,
          language: _lang,
          cancel: _cancelUrl
        };
        uteReserveDeviceNRSDataService.getEncryptNRSData(_req, function (_data) {
          if (_data.result === 'success') {
            if (_data.data.data.userCustomerBANInfo) {
              vm.encryptedString = _.unescape(_data.data.data.userCustomerBANInfo);
            }
            if (_data.data.data.userCustomerBANInfoSignature) {
              vm.encryptedSignature = _data.data.data.userCustomerBANInfoSignature;
            }
            $scope.$emit('loadSalesForceFrame', null);
          } else if (_data.result === 'fail') {
            $rootScope.salesForceFailed = true;
            notifierService.notify('technical');
          } else if (_data.result === 'error') {
            $rootScope.salesForceFailed = true;
            notifierService.notify('technical');
            //$rootScope.salesForceFailed = false; //debug
            //vm.encryptedString = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><ns2:RogersNRSInfo xmlns:ns2="http://wireless.rogers.com/schemas/ReserveDevice/NRS"><UserInfo><userId>c0014fd1-1658-44f9-85be-cec93e86adff</userId><userEmail>postpaid@715.com</userEmail></UserInfo><BanInfo><BanDetails><CTNs><CTNInfo><ctn>4162623678</ctn><selectedCTN>true</selectedCTN></CTNInfo><CTNInfo><ctn>4162622984</ctn><selectedCTN>false</selectedCTN></CTNInfo></CTNs><Customer><Name><firstName>DONTUSE</firstName><lastName>TOTESDQAQG</lastName><initial></initial><additionalTitle></additionalTitle><title></title><suffix></suffix></Name><BillingAddress><primaryLine>***,</primaryLine><secondaryLine></secondaryLine><additionalLine></additionalLine><aptNumber></aptNumber><aptDesignator></aptDesignator><city></city><province>**</province><country></country><postCode></postCode><attention></attention></BillingAddress><ContactInformation><workTelExtNo></workTelExtNo><workTelNo>4162222222</workTelNo><homeTelNo>4161111111</homeTelNo><emailAddressV21></emailAddressV21><contactPhoneNumber></contactPhoneNumber><faxNumber></faxNumber></ContactInformation></Customer><selectedBAN>true</selectedBAN><ban>728189904</ban></BanDetails><BanDetails><CTNs><CTNInfo><ctn>4162580098</ctn><selectedCTN>false</selectedCTN></CTNInfo></CTNs><Customer><Name><firstName>JOHN</firstName><lastName>CASTOR</lastName><initial></initial><additionalTitle></additionalTitle><title></title><suffix></suffix></Name><BillingAddress><primaryLine>***,</primaryLine><secondaryLine></secondaryLine><additionalLine></additionalLine><aptNumber></aptNumber><aptDesignator></aptDesignator><city></city><province>**</province><country></country><postCode></postCode><attention></attention></BillingAddress><ContactInformation><workTelExtNo></workTelExtNo><workTelNo></workTelNo><homeTelNo>4168169457</homeTelNo><emailAddressV21></emailAddressV21><contactPhoneNumber></contactPhoneNumber><faxNumber></faxNumber></ContactInformation></Customer><selectedBAN>false</selectedBAN><ban>728194695</ban></BanDetails></BanInfo><RogersIntInfo/><locale>en</locale></ns2:RogersNRSInfo>';
            //vm.encryptedSignature = 'C1czPCVVV8PlN3ptegFiKjVfBIvZDg0TZmzA6xhnx80=';
            //$scope.$emit('loadSalesForceFrame', null);
          }
        });
      } else {
        //$('#formToRogersReserveDevice').attr('action', settings.formsURL + '/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice' + '&setLanguage=' + $scope.lng);
        //$('#formToRogersReserveDevice').submit();
        window.location.href = '/web/page/portal/Fido/Ecare_ReserveDevice';
      }
      //} else {
      //  $rootScope.salesForceFailed = true;
      //}
      //});
    }
  }

})();
